import React from 'react';
import { useTranslation } from 'react-i18next';
import VideoTileGridV2 from '../VideoTileGrid';
import { StageVideoWrap } from './style';
import { SideBySideIcon, SingleViewIcon } from '../MeetingIcons';

const StageVideoArea = ({
  users,
  localCameraOn,
  noRemoteVideoView,
  normalLayoutMode,
  onToggleNormalLayoutMode,
  isAnyUserSharing,
}) => {
  const { t } = useTranslation();
  const displayLayoutMode = isAnyUserSharing ? 'single' : normalLayoutMode;
  const switchToSingleLabel = t('VideoChatV2.layout.switchToSingle');
  const switchToSideBySideLabel = t('VideoChatV2.layout.switchToSideBySide');
  const disabledDuringShareLabel = t('VideoChatV2.layout.disabledDuringShare');
  const layoutTooltip = isAnyUserSharing
    ? disabledDuringShareLabel
    : (displayLayoutMode === 'side-by-side' ? switchToSingleLabel : switchToSideBySideLabel);

  return (
  <StageVideoWrap>
    <div
      className={`stage-layout-toggle-wrap ${isAnyUserSharing ? 'disabled' : ''}`}
      data-tooltip={layoutTooltip}
      tabIndex={isAnyUserSharing ? 0 : -1}
      aria-label={isAnyUserSharing ? layoutTooltip : undefined}
    >
      <button
        type="button"
        className={`dock-icon-btn dock-layout-btn ${displayLayoutMode === 'side-by-side' ? 'active' : ''}`}
        onClick={onToggleNormalLayoutMode}
        disabled={isAnyUserSharing}
        aria-disabled={isAnyUserSharing}
        aria-label={layoutTooltip}
      >
        {displayLayoutMode === 'side-by-side' ? <SingleViewIcon /> : <SideBySideIcon />}
      </button>
    </div>
    <VideoTileGridV2
      layout="featured"
      users={users}
      localCameraOn={localCameraOn}
      noRemoteVideoView={noRemoteVideoView}
      normalLayoutMode={normalLayoutMode}
    />
  </StageVideoWrap>
  );
};

export default React.memo(StageVideoArea);
